<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="600"
  >
    <v-card>
      <v-card-text>
        <img :src="foto" alt="No se encontro foto">
        <v-card-actions class="pa-2">
            <v-btn
              outlined
              @click="close"
            >
              Cerrar
            </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

  export default {
    props: {
      // foto: {
      //   type: String,
      //   required: true
      // }
    },
    data () {
      return {
        dialog: false,
        loading: false,
        foto: ''
      }
    },
    mounted () {
    },
    methods: {
      async open (foto) {
        this.dialog = true
        this.foto = foto
      },
      close () {
        this.dialog = false
      },
    },
  }
</script>
